module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ellen Ullman, Mary Gaitskill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Ellen Ullman")]), _vm._v(" is an American computer programmer and author. She has written novels as well as articles for various publications, including "), _c('I', [_vm._v("Harper's Magazine")]), _vm._v(", "), _c('I', [_vm._v("Wired")]), _vm._v(", "), _c('I', [_vm._v("The New York Times")]), _vm._v(", and "), _c('I', [_vm._v("Salon")]), _vm._v(". Her essays and novels analyze the human side of the world of computer programming. Ullman earned a bachelor's degree  in English at Cornell University in the early 1970s. She then turned to business programming in the following years. She eventually began writing about her experiences as a programmer in 1995 when she wrote an essay titled \"Out of Time: Reflections on the Programming Life.\" She lives in San Francisco.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UCx10R/tc-custom/9781250024572.jpg?1739474634125",
      "alt": "This image is the cover for the book Bug"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bug\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("With a New Introduction by Mary Gaitskill "), _c('br'), _c('br'), _vm._v("A PEN/Hemingway Award Finalist "), _c('br'), _c('br'), _vm._v("A "), _c('i', [_vm._v("New York Times Book Review")]), _vm._v(" Notable Book "), _c('br'), _c('br'), _vm._v("Ellen Ullman is a \"rarity, a computer programmer with a poet's feeling for language\" (Laura Miller, "), _c('i', [_vm._v("Salon")]), _vm._v("). "), _c('i', [_vm._v("The Bug")]), _vm._v(" breaks new ground in literary fiction, offering us a deep look into the internal lives of people in the technical world. Set in a start-up company in 1984, this highly acclaimed first novel explores what happens when a baffling software flaw—a bug so teasing it is named \"the Jester\"—threatens the survival of the human beings who created it.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0